
const appArray = ["Platform","KPISummaryView","KPISummaryViewV2","KPITrendView","KPTLPlanVsActual","KPITrendV2","KPIDistributionV2","ErisSalesGrowthComponent","KPTLWidgets","ErisWidgets","HawkeyeKPIOverview","MonitorFirstWidget","AnalyticsForecastCustomWidget","COVID19MapWithDistribution","BoxAndWhiskerPlotChart","PivotWithTrend","InsightsPivotApp","WaterfallChart","PriceChangeWithGroupColumnChart"];
module.exports = {
  appArray,
};
  